var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluePlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3336 15.7442V16.4108C25.3336 16.779 25.0352 17.0775 24.667 17.0775H17.0003V24.7442C17.0003 25.1123 16.7018 25.4108 16.3336 25.4108H15.667C15.2988 25.4108 15.0003 25.1123 15.0003 24.7442V17.0775H7.33366C6.96547 17.0775 6.66699 16.779 6.66699 16.4108V15.7442C6.66699 15.376 6.96547 15.0775 7.33366 15.0775H15.0003V7.4108C15.0003 7.04261 15.2988 6.74414 15.667 6.74414H16.3336C16.7018 6.74414 17.0003 7.04261 17.0003 7.4108V15.0775H24.667C25.0352 15.0775 25.3336 15.376 25.3336 15.7442Z",
    fill: "#002E6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePlus);
export default __webpack_public_path__ + "static/media/bluePlus.24daa2027bc540ec4dbe15ef01d8cfb6.svg";
export { ForwardRef as ReactComponent };